import React from "react";

const Productos = () => {
  return (
    <>
      <div className="container">
        <div className="row row-jm">
          {/*     /////////////////servicios//////////////////////////////// */}

          <div className="col-md-6 col-sm-12 mt-5">
            <h2 className="mt-4 sobre-nosotras-title">PRODUCTOS</h2>
          </div>
          <div className="col-md-12 col-sm-12 mt-5">
            <h3>
              Contamos con diferentes productos que ayudarán a implementar
              accesibilidad a tus espacios.
            </h3>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/pictograma.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left mt-3">
              <strong style={{ color: "#000" }}>Pictogramas</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Señalización para identificar ambientes mediante pictograma,
                braille y alto relieve. Pregunta por nuestras diferentes
                opciones y materiales.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/sena.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>
                Señalización accesible orientativa
              </strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Mejora la accesibilidad en tu edificación con estos paneles
                orientativos en braille y alto relieve, diseñado para guiar a
                tus usuarios de forma clara y segura.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/p3.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>
                Señalización accesible informativa
              </strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Con estas señalizaciones indica claramente el nombre de cada
                ambiente y su función, garantizando inclusión y autonomía para
                todos.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/eva.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>
                Señalización accesible de evacuación y emergencia
              </strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Con nuestras señalizaciones de evacuación y emergencia en
                braille y alto relieve pueden completar la ruta de evacuación
                accesible de tu empresa.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/plano.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Planos hápticos</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Planos en alto relieve, en braille y de fácil comprensión, son
                obligatorios en espacios de atención al público. ¡Incluye
                accesibilidad en tu espacio con uno de nuestros planos!
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/panel.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Paneles interpretativos</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Con estos paneles mejora la experiencia de tus visitantes. Con
                imágenes en relieve y braille, facilitan la comprensión de
                entornos naturales, edificaciones patrimoniales, fauna y más,
                permitiendo una experiencia inclusiva para todos.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/cartilla.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Cartilla informativa</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Nuestra cartilla informativa ofrece datos impresos, en braille y
                alto relieve sobre entornos urbanos, turísticos o planos de
                edificaciones, brindando una orientación clara y accesible al
                alcance de tu mano.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/p8.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Papelería en braille</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Facilita el acceso a la información con nuestra impresión en
                braille. Desde menús para restaurantes hasta material
                corporativo, hacemos que tu empresa sea más inclusiva para
                todos.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/piso.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Piso podotáctil</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Nuestro piso podotáctil de fácil instalación mejora la
                orientación y seguridad en tu espacio. Te asesoramos en el
                diseño del recorrido adecuado para una mayor eficacia en su
                aplicación.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/p10.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>
                Barras de seguridad y barandas
              </strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Fabricamos e instalamos barras fijas y abatibles de acero
                inoxidable para servicios higiénicos, así como barandas
                cumpliendo con la normativa vigente y garantizando accesibilidad
                y seguridad.
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/rampa.jpg")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Rampas portátiles</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Nuestras rampas portátiles permiten superar desniveles sin
                necesidad de modificar la edificación, siendo la solución ideal
                para espacios patrimoniales o alquilados
              </p>
            </p>
          </div>
          <div className="col-md-4 col-sm-12 mt-4 text-left">
            <img
              src={require("../assets/productos/p12.png")}
              alt="Imagen vertical"
              className="img-vertical"
              style={{
                width: "350px",
                height: "250px",
                marginLeft: "-10px",
              }}
            />
            <p className="mitexto text-left  mt-3">
              <strong style={{ color: "#000" }}>Chef’s Voice</strong>
              <br></br>
              <p style={{ marginRight: 45, fontsize: 11 }}>
                Con nuestra aplicación, tu restaurante u hotel podrá ofrecer un
                menú accesible desde el celular, con audio y detalles sobre
                alérgenos. Escríbenos para más información o probarlo.
              </p>
            </p>
          </div>

          <h5 className="mitexto text-left  mt-3" style={{ fontSize: 16 }}>
            <br></br>
            Contamos con proveedores que son reconocidos por su calidad en sus
            productos y confían en nosotros para su implementación.
            <br></br>Las señalizaciones y planos hápticos son productos impreso
            por PuntoDis®. Somos aliados y distribuidores de sus productos.
            <br></br>Los pisos podotáctiles de Taktila®, empresa comprometida en
            brindar accesibilidad, seguridad y sostenibilidad en sus productos.
          </h5>

          <div className="col-md-12 col-sm-12 mt-5 mb-5"></div>
        </div>
      </div>
    </>
  );
};

export default Productos;
